angular.module('satv.mediastats')
.factory('StatLoader', ['Stat', 'LoaderFactory', function(Stat, LoaderFactory) {
    return function(params) {
        return new LoaderFactory(Stat, params, {
            resultSet: 'data'
        });
    };
}])


// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/services/StatLoader.js